import { injectGlobal, keyframes } from 'emotion';
import { flipCard } from './flipCard.styles';
import { matching } from './matching.styles';
import { clickAndReveal } from './clickAndReveal.styles';
import { focusBorder } from './variables';

const fader = keyframes`
from {
	opacity: 0;
}
to {
	opacity: 1;
}
`;

injectGlobal`

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;

		&::-webkit-scrollbar {
			width: 5px;
		}
		
		&::-webkit-scrollbar-track {
			background-color: lightgrey;
		}
		
		&::-webkit-scrollbar-thumb {

			background-color: darkgrey;
		}

		-webkit-tap-highlight-color: transparent;
	}
	
	html, body {
		width: 100%;
		height: 100%;

	}

	body {
		font-family: 'Poppins', sans-serif;
		font-weight: 300;
		overflow-anchor: none;

		
	}

	h1, h2, h3, h4 {
		font-weight: 200;
		line-height: 1.2em;
	}

	h1 {
			font-size: 2rem;
	}

	h2 {
			font-size: 1.5rem;
	}

	h3 {
			font-size: 1.3rem;
	}

	h4 {
			font-size: 1rem;
	}


	@media(min-width: 480px) {
			h1 {
					font-size: 2.5rem;
			}

			h2 {
					font-size: 2rem;
			}

			h3 {
					font-size: 1.8rem;
			}

			h4 {
					font-size: 1.5rem;
			}
	}

	@media(min-width: 767px) {
			h1 {
					font-size: 3.5rem;
			}

			h2 {
					font-size: 2.5rem;
			}

			h3 {
					font-size: 2rem;
			}

			h4 {
					font-size: 1.2rem;
			}
	}


	p strong {
		font-weight: 700 !important;
	}

	strong {
		font-weight: 700 !important;
	}

	input[type=text] {
		font-weight: 300;
	}

	img {
		align-self: center;
		vertical-align: bottom;
		max-width: 100%;
		flex-shrink: 0;
	}


	form {
		width: 100%;
	}

	#root {
		width: 100%;
		height: 100%;
	}

	.chameleon-text {
		width: 100%;

		overflow-wrap: break-word;
		word-wrap: break-word;
		word-break: break-word;

		p, li {
			
		line-height: 1.5em;

		}

		p span {
			// line-height: 1.5em;
		}
	}

	h1, h2, h3, h4 {

		li {
			margin-left: .5em;
		}

		ol {
			position: relative;
			left: .5em;
		}

		ol li:before {
	
			padding-left: 10px !important;
		}

	}

	p,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	strong, 
	em, 
	u {
		max-width: 100%;
	}


	.fader_-2s {
		animation: ${fader} 0.2s forwards;
	}

	.fader_-5s {
		animation: ${fader} 0.5s forwards;
	}

	.fader_1s {
		animation: ${fader} 1s forwards;
	}

	button {
		font-family: inherit !important;
	}

	input {
		:focus {
			border: ${focusBorder};
		}
	}

	textarea {
		:focus {
			border: ${focusBorder};
		}
	}

	.wtf {
		border: 10px solid green;
			}



	pre {
		display: flex;
		padding: 0 !important;
		border: none !important;
	}

	code {
		display: inline;
		padding: 10px 20px 20px 10px !important;
		border-radius: 3px;
		background: #eaeffb;
	}

	*:focus {
		outline: none;
	}

	a:link {
		color: #0000EE;
	}

	a:visited {
		// color: #0073E6 !important;
	}

	a:hover {
		text-decoration: none;
	}

	a:active {
		color: red;
	}


	a:focus {
		// text-decoration: none;
		// opacity: 0.45;
	}

	.center-text {
		text-align: center;
	}

	.chameleon-text-align-left, [data-type="textAlignLeft"] {
		text-align: left;

		ul, ol {
			list-style-position: outside !important;		
		}
	}

	.chameleon-text-align-center, [data-type="textAlignCenter"] {
		text-align: center;

		ul, ol {
			list-style-position: inside;		
		}

		> ul, > ol {
			display: inline-block;
			margin-left: 0px !important;
		}

	}

	.chameleon-text-align-right, [data-type="textAlignRight"] {
		text-align: right;

		ul, ol {
			list-style-position: inside;		
		}
	
		> ul, > ol {
			display: inline-block;
			margin-left: 0px;
		}
	  
	}

	// https://gist.github.com/ffoodd/000b59f431e3e64e4ce1a24d5bb36034
	.sr-only {
		border: 0 !important;
		clip: rect(1px, 1px, 1px, 1px) !important; 
		-webkit-clip-path: inset(50%) !important;
			clip-path: inset(50%) !important;  
		height: 1px !important;
		margin: -1px !important;
		overflow: hidden !important;
		padding: 0 !important;
		position: absolute !important;
		width: 1px !important;
		white-space: nowrap !important;            
	}

	.lang-bracket::before {
		content: '[';
		 color: rgb(64, 64, 64);
	}

	.lang-bracket::after {
		content: ']';
		 color: rgb(64, 64, 64);
	}

	${flipCard}
	${matching}
	${clickAndReveal}

	}

`;
